/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Drop_FrameInputs */



/**
* | output |
* | --- |
* | "Dropframe" |
*
* @param {Subtitle_Export_Drop_FrameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_drop_frame = /** @type {((inputs?: Subtitle_Export_Drop_FrameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Drop_FrameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cadre de chute")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dropframe")
	if (locale === "it") return /** @type {LocalizedString} */ ("Telaio a caduta")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Dropframe")
	if (locale === "es") return /** @type {LocalizedString} */ ("Dropframe")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("掉帧")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ドロップフレーム")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ड्रॉपफ्रेम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Dropframe")
	return /** @type {LocalizedString} */ ("Dropframe")
});